import React from "react";

const ASP_Error = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Error</h1>
      <p>This is the ASP Error page content.</p>
    </div>
  );
};

export default ASP_Error;
